import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { Params } from '@angular/router';

@Component({
  selector: 'un-info-widget',
  templateUrl: './info-widget.component.html',
  styleUrls: ['./info-widget.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class InfoWidgetComponent {
  @Input() heading: string;
  @Input() description: string;
  @Input() link?: string;
  @Input() linkText = $localize`Learn More`;
  @Input() linkClass = 'c-primary';
  @Input() actionBtn?: string;
  @Input() actionBtnLink?: string;
  @Input() actionBtnQuery?: Params;
  @Input() noPadding = false;
  @Input() hideActionBtn = false;
  @Output() actionBtnClicked = new EventEmitter<void>();
}
